// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Mapper  {
    _originalTypeClassName = "Loom.BO.Mapper";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Mapper.translate = translateService;
}
this.Id = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }

static MapRelationshipToEmployeeDTO(c: any): any{let dto = new Domain.EmployeeVM();
dto.PersonId = c?.Person?.Id;
dto.FirstName = c?.Person?.FirstName;
dto.LastName = c?.Person?.LastName;
dto.FullName = c?.Person?.FullName + " (" + c?.Organisation?.ShortName + ")";
dto.CallName = c?.Person?.CallName;
dto.Email = c?.Person?.Email;
dto.EmployeeId = c?.Id;
dto.OrgId = c?.Organisation?.Id;
dto.OrgShortName = c?.Organisation?.ShortName;
dto.OrgName = c?.Organisation?.LegalName;
dto.BasedInCountryCode = c?.Person?.BasedInCountry?.ISOCode2;
dto.BasedInCountryName = c?.Person?.BasedInCountry?.Name;
return dto;
}
static MapTimesheetEntryToDTO(t: any): any{let entrydto = new Domain.TimesheetEntryVM();
entrydto.Id = t?.Id;
entrydto.HoursWorked = t?.HoursWorked;
entrydto.ProjectAcronym = t?.WorkPackage?.Project?.Acronym;
entrydto.WPId = t?.WorkPackage?.Id;
entrydto.WPNumber = t?.WorkPackage?.WPNumber;
entrydto.WPTitle = t?.WorkPackage?.Name;
entrydto.FQN = t?.WorkPackage?.FQN;
entrydto.WPStartDate = new Date(new Date(t?.WorkPackage?.StartDate)?.setHours(0, 0, 0, 0));
entrydto.WPEndDate = new Date(new Date(t?.WorkPackage?.EndDate)?.setHours(0, 0, 0, 0));
entrydto.Id = t?.Timesheet?.Id;
entrydto.Month = new Date(new Date(t?.Timesheet?.Month)?.setHours(0, 0, 0, 0));
entrydto.Status = t?.Timesheet?.Status;
if (((t?.Timesheet?.DateApproved != null))) {entrydto.DateApproved = t?.Timesheet?.DateApproved;}
if (((t?.Timesheet?.DateSubmitted != null))) {entrydto.DateSubmitted = t?.Timesheet?.DateSubmitted;}
entrydto.Employee = t?.Timesheet?.EmploymentContract?.EmployeeAndCompany;
entrydto.Approver = t?.Timesheet?.ApprovedBy?.FullName;
entrydto.SubmittedBy = t?.Timesheet?.SubmittedBy?.FullName;
return entrydto;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}